import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { THEME } from '../../config/theme';

interface Props {
  title: React.ReactNode;
  children?: React.ReactNode;
}

// A label with an (i) beside it. Every tooltip on the Model Beliefs page
// announces itself this way, so a reader knows where there is more to read
// without hovering at random.
export const InfoTip: React.FunctionComponent<Props> = ({ title, children }) => (
  <Tooltip title={title}>
    <span style={{ cursor: 'help', whiteSpace: 'nowrap' }}>
      {children}
      <InfoCircleOutlined
        style={{ marginLeft: 4, fontSize: 12, color: THEME.textSecondary, verticalAlign: 'middle' }}
      />
    </span>
  </Tooltip>
);
